<template>
   <div id="page">
      <site-header title="Appriana"></site-header>
      <div class="content-row">
         <h1> Resource Not Found </h1>
         <p> Please verify the URL path and try again. </p>
      </div>
   </div>
</template>

<script>
function initialData() {
   return {}
}
export default {
   data: initialData,
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* + Page */
#page {
   height: 99vh;   
   width: 64rem;
   margin: auto;
}
.content-row {
   margin: auto;
   width: auto;
   padding-top: 24vh;
   height: 46vh;
   text-align: center;
}
/* - Page */

/* + Page Wide */
a, u {
    text-decoration: none;
}

h1 {
   font-weight: normal;   
   font-size: 1.8rem;
}

/* - Page Wide */
</style>


// WEBPACK FOOTER //
// src/components/common/NotFound.vue